export default __webpack_public_path__ + "static/media/google-play-badge.4d407e60.png";